import React from 'react';
import { Box, alpha, useTheme } from '@mui/material';
import { CONTENT_SHAPE } from '../constants/contentColors';
import { contentBorders } from '../theme/createContentTheme';

interface PageTitleIconProps {
  /** Icon element (typically the page's sidebar icon) shown inside the badge. */
  icon: React.ReactNode;
  /** Square size in px. */
  size?: number;
}

/** Small architectural square holding a page's icon next to its title. */
const PageTitleIcon: React.FC<PageTitleIconProps> = ({ icon, size = 36 }) => {
  const theme = useTheme();
  return (
    <Box
      aria-hidden
      sx={{
        width: size,
        height: size,
        flexShrink: 0,
        borderRadius: `${CONTENT_SHAPE.sm}px`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: `1px solid ${contentBorders(theme).default}`,
        bgcolor: alpha(theme.palette.primary.main, theme.palette.mode === 'dark' ? 0.12 : 0.06),
        color: theme.palette.primary.main,
        '& svg': { fontSize: Math.round(size * 0.55) },
      }}
    >
      {icon}
    </Box>
  );
};

export default PageTitleIcon;
